/* src/app/screen-recorder/screen-recorder.component.scss */
:host {
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.video-super {
  width: 60%;
  position: absolute;
  z-index: 500;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px;
  border-radius: 4px;
  border-style: solid;
  border-width: thin;
}
.video-super-edit {
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  overflow: auto;
}
.video-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.view-component-title {
  justify-content: flex-end;
  font-size: 18px;
  max-height: 45px;
}
.main-container-edit {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}
.main-container {
  display: flex;
  flex-direction: column;
}
.save-button {
  position: fixed;
  top: -40px;
  left: 0;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
}
.save-button-edit {
  position: absolute;
  top: 10px;
  left: 10px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  display: flex;
  border-style: solid;
  border-width: 1px;
}
.float-button {
  position: absolute;
  z-index: 100;
  display: flex;
  flex-direction: row;
  left: 45%;
  top: 3px;
  border-radius: 4px;
  border: 1px solid var(--tem-border);
}
.button {
  display: flex;
  flex-direction: column;
  align-items: center;
}
/*# sourceMappingURL=screen-recorder.component.css.map */
